<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Dodaj notatkę
  </div>

  <div  fxFlex="100">
    <mat-form-field fxFlex="100">
      <mat-label>Notatka</mat-label>
      <textarea [formControl]="noteControl"  matInput placeholder="Notatka" rows="10" autofocus ></textarea>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

